import React from "react";
import { Download, ArrowRight } from "lucide-react";
import { toast } from "../hooks/use-toast";

const GUIDE_URL =
  "https://customer-assets-wrfwihn1.emergentagent.net/job_responsive-rebuild-32/artifacts/fmn4c7yx_Setup%20Guide%20%281%29.docx";
const GUIDE_FILENAME = "Setup Guide.docx";

const Hero = () => {
  const handleDownload = () => {
    toast({
      title: "Downloading Setup Guide…",
      description: "Your free copy should start downloading shortly.",
    });
  };

  const scrollToHow = () => {
    const el = document.getElementById("how-it-works");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="top" className="relative pt-8 sm:pt-14 pb-6 sm:pb-10">
      {/* Soft background pattern */}
      <div className="absolute inset-0 bg-soft-grid opacity-70 pointer-events-none" />
      <div className="absolute top-0 inset-x-0 h-64 bg-gradient-to-b from-blue-50 to-transparent pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Hero statement */}
        <div className="max-w-5xl mx-auto animate-fade-in-up">
          <p className="text-center font-extrabold tracking-tight text-slate-900 text-2xl sm:text-4xl lg:text-5xl leading-tight sm:leading-[1.15]">
            Most website visitors{" "}
            <span className="text-red-600 animate-emphasis-blink">leave</span>{" "}
            without contacting your business because they have{" "}
            <span className="relative inline-block">
              <span className="relative z-10 text-blue-700">
                unanswered questions.
              </span>
              <span
                aria-hidden
                className="absolute left-0 right-0 bottom-0.5 sm:bottom-1 h-2 sm:h-3 bg-blue-200/70 -z-0 rounded-sm"
              />
            </span>
          </p>

          <p className="mt-5 sm:mt-8 text-center font-medium sm:font-semibold text-slate-700 text-lg sm:text-2xl lg:text-3xl leading-relaxed sm:leading-snug animate-fade-in-up delay-100 max-w-2xl sm:max-w-none mx-auto">
            Our{" "}
            <span className="text-blue-600 font-bold sm:font-extrabold">
              human agents
            </span>{" "}
            start{" "}
            <span className="italic text-slate-900">real conversations</span>{" "}
            and answer their questions while they&rsquo;re still on your
            website
            <span className="hidden sm:inline"> &mdash; </span>
            <span className="sm:hidden">, </span>
            helping turn more of them into{" "}
            <span className="relative inline-block">
              <span className="relative z-10 text-emerald-600 font-bold sm:font-extrabold">
                customers.
              </span>
              <span
                aria-hidden
                className="absolute left-0 right-0 bottom-0.5 sm:bottom-1 h-1.5 sm:h-2.5 bg-emerald-200/70 -z-0 rounded-sm"
              />
            </span>
          </p>
        </div>

        {/* CTA */}
        <div
          id="download"
          className="mt-8 sm:mt-10 flex flex-col items-center justify-center gap-4 animate-fade-in-up delay-200"
        >
          <a
            href={GUIDE_URL}
            download={GUIDE_FILENAME}
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleDownload}
            className="group inline-flex items-center justify-center bg-blue-600 hover:bg-blue-700 text-white font-bold rounded-2xl px-10 sm:px-14 py-6 sm:py-7 text-lg sm:text-xl shadow-xl shadow-blue-600/30 hover:shadow-2xl hover:shadow-blue-600/40 hover:-translate-y-0.5 transition-all"
          >
            <Download className="w-6 h-6 mr-3" />
            Free Download
            <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default Hero;
